import { render, staticRenderFns } from "./home-footer-nav.vue?vue&type=template&id=49a5e7b0&"
import script from "./home-footer-nav.vue?vue&type=script&lang=js&"
export * from "./home-footer-nav.vue?vue&type=script&lang=js&"
import style0 from "./home-footer-nav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports